export default {
  accountHistory: [{ CurrentState: "Undefined" }],
  appointments: [{ CurrentState: "Undefined" }],
  availableDates: [{ CurrentState: "Undefined" }],
  availableHours: [{ CurrentState: "Undefined" }],
  availableServices: [{ CurrentState: "Undefined" }],
  completedDocument: [{ CurrentState: "Undefined" }],
  devices: [{ CurrentState: "Undefined" }],
  documents: [{ CurrentState: "Undefined" }],
  invoice: [{ CurrentState: "Undefined" }],
  selectedLanguage: [{ CurrentState: "Undefined" }],
  locations: [{ CurrentState: "Undefined" }],
  nextPayment: [{ CurrentState: "Undefined" }],
  notifications: [{ CurrentState: "Undefined" }],
  paymentMethod: [{ CurrentState: "Undefined" }],
  profile: [{ CurrentState: "Undefined" }],
  programTypes: [{ CurrentState: "Undefined" }],
  reportSignatures: [{ CurrentState: "Undefined" }],
  report: [{ CurrentState: "Undefined" }],
  states: [{ CurrentState: "Undefined" }],
  vehicle: [{ CurrentState: "Undefined" }],
};
